/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AiChatbotRequest
 */
export interface AiChatbotRequest {
    /**
     *
     * @type {string}
     * @memberof AiChatbotRequest
     */
    question?: string;
}

/**
 * Check if a given object implements the AiChatbotRequest interface.
 */
export function instanceOfAiChatbotRequest(
    value: object,
): value is AiChatbotRequest {
    return true;
}

export function AiChatbotRequestFromJSON(json: any): AiChatbotRequest {
    return AiChatbotRequestFromJSONTyped(json, false);
}

export function AiChatbotRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): AiChatbotRequest {
    if (json == null) {
        return json;
    }
    return {
        question: json["question"] == null ? undefined : json["question"],
    };
}

export function AiChatbotRequestToJSON(value?: AiChatbotRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        question: value["question"],
    };
}
